import React from 'react';
import pt from 'prop-types';

import AppReviewPreviousVersions from './previous-versions';
import AppReviewThread from './thread';
import { getReviewThreads } from './utils';

import './review.scss';

export default class AppReview extends React.PureComponent {
  static propTypes = {
    app: pt.object.isRequired,
    // A version's review is opened by its first comment, which only the
    // reviewer writes; the portal answers the thread it finds
    canStartThread: pt.bool,
    canAddInternal: pt.bool,
    onCreateComment: pt.func,
    onUpdateComment: pt.func,
    onDeleteComment: pt.func,
  };

  renderThread(version, thread) {
    const {
      canAddInternal,
      onCreateComment,
      onUpdateComment,
      onDeleteComment,
    } = this.props;

    return (
      <AppReviewThread
        key={version}
        version={version}
        thread={thread}
        canAddInternal={canAddInternal}
        onCreateComment={onCreateComment}
        onUpdateComment={onUpdateComment}
        onDeleteComment={onDeleteComment}
      />
    );
  }

  render() {
    const { app, canStartThread } = this.props;
    const { openVersion, active, previous, closedCount } =
      getReviewThreads(app);
    // The reviewer opens the review of a version that has none yet
    const canOpenReview =
      canStartThread && Boolean(openVersion) && active.length === 0;
    const isEmpty = active.length === 0 && closedCount === 0 && !canOpenReview;

    return (
      <div className="review-comments">
        <h3>Comments</h3>
        {isEmpty && <span className="muted">No review comments yet</span>}
        {closedCount > 0 && (
          <AppReviewPreviousVersions
            groups={previous}
            closedCount={closedCount}
          />
        )}
        {active.map((thread) => this.renderThread(thread.version, thread))}
        {canOpenReview && this.renderThread(openVersion)}
      </div>
    );
  }
}
